import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { API } from "@/lib/api";
import { playChime } from "@/lib/sound";

// Opens an SSE stream and delivers live dap notifications as in-app toasts,
// and tells the bell to refresh. OS-level alerts are handled by the service
// worker (Web Push), so they arrive even when this tab is closed.
export default function NotificationStream() {
  const navigate = useNavigate();
  const esRef = useRef(null);

  useEffect(() => {
    let closed = false;
    let retry;

    const connect = () => {
      if (closed) return;
      const es = new EventSource(`${API}/notifications/stream`, { withCredentials: true });
      esRef.current = es;

      es.onmessage = (e) => {
        let data;
        try { data = JSON.parse(e.data); } catch (_) { return; }
        if (data.type !== "notification") return;
        const n = data.notification;
        window.dispatchEvent(new CustomEvent("dl-notify"));
        playChime();
        toast(n.title, {
          description: n.body,
          action: n.dap_id
            ? { label: "View", onClick: () => navigate(`/dap/${n.dap_id}`) }
            : undefined,
        });
      };

      es.onerror = () => {
        es.close();
        if (!closed) {
          clearTimeout(retry);
          retry = setTimeout(connect, 5000);
        }
      };
    };

    connect();
    return () => {
      closed = true;
      clearTimeout(retry);
      if (esRef.current) esRef.current.close();
    };
    // API is a module-level constant; navigate is stable. Reconnection is self-managed.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);

  return null;
}
